import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Sheet } from "react-modal-sheet";
import { useSearchParamsOfBooking } from "../../hooks/searchParams/useSearchParamsOfBooking";
import clsx from "clsx";
import { useResponsive } from "../../hooks/useResponsive";
import { mergeClass } from "../../utils/common";
import { IcBtnSm } from "../button/IcBtn";
import AddToCartBtn from "../detail/AddToCartBtn";
import { icArrowDown } from "../image/image-src";
import { SvgClose } from "../svg/SvgClose";
import BookingCardBody from "./BookingCardBody";
import { PriceDetailSummary } from "./PriceRowArea";
import { useBookingCard } from "./useBookingCard";
const BookingCardBottom: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();
  const { editBookingId, isEdit, isUpgrade } = useSearchParamsOfBooking();
  const useBookingCardProps = useBookingCard({
    editBookingId,
    isEdit,
    isUpgrade,
  });
  // mobile only
  const responsive = useResponsive();
  if (responsive.isTabletLg) return null;

  return (
    <>
      <Sheet
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        detent="content-height"
      >
        <Sheet.Container>
          <Sheet.Header>
            <div className="flex h-6 items-center justify-center">
              <div className="h-1.5 w-12 rounded-full bg-gray-400" />
            </div>
          </Sheet.Header>

          <Sheet.Content disableDrag>
            <div className="relative mb-4 flex h-[2.625rem] flex-row items-center justify-between rounded-t-2xl px-4 pb-[1rem] pt-4">
              <h3 className="h-[1.625rem] text-lg font-semibold not-italic leading-[1.625rem] text-[#232323]">
                {t("Your option")}
              </h3>
              <button
                type="button"
                className="absolute right-0 mr-4 size-5"
                onClick={() => setOpen(false)}
              >
                <SvgClose />
              </button>
            </div>

            <div className="mb-[7rem] overflow-y-auto overscroll-contain bg-white px-4">
              <BookingCardBody useBookingCardProps={useBookingCardProps} />
            </div>
          </Sheet.Content>
        </Sheet.Container>
      </Sheet>

      <div
        className={mergeClass(
          "fixed bottom-0 flex w-full justify-between gap-2 bg-white p-2 px-4 pb-[2.125rem] shadow-[0_1px_47px_0_#00000017]",
          isOpen ? "z-[10000]" : "z-20",
        )}
      >
        <PriceDetailSummary useBookingCardProps={useBookingCardProps}>
          <IcBtnSm
            className={clsx("wei-1 size-6", isOpen ? "rotate-180" : "")}
            ic={icArrowDown}
            onClick={() => {
              setOpen((prev) => !prev);
            }}
          />
        </PriceDetailSummary>
        <div className="ml-auto flex w-full items-end justify-end lg:w-[7.75rem]">
          <AddToCartBtn useBookingCardProps={useBookingCardProps} />
        </div>
      </div>
    </>
  );
};

export default BookingCardBottom;
